<div class="legend-container">
    <div class="return-container" (click)="onLegendConsultClick()">
        <fa-icon class="return-icon-mobile" [icon]="faReturn"></fa-icon>
        <label class="return-title">{{ 'MAP.LEGENDS.RETURN' | translate }}</label>
    </div>

    <div class="legend-section">
        <div class="header">{{ 'MAP.LEGENDS.HEADER.LAYER' | translate }}</div>
        <div *ngFor="let layer of layers" class="layer-field">
          <fa-icon [icon]="layer.icon" [classList]="layer.class"></fa-icon>
          <span>{{ layer.label | translate }}</span>
        </div>
      
        <div class="header">{{ 'MAP.LEGENDS.HEADER.TRENDS' | translate }}</div>
        <div *ngFor="let trend of trends" class="trend-field">
          <i [class]="trend.icon"></i>
          <span>{{ trend.label | translate }}</span>
        </div>
      </div>

      <div class="level-section">
        <div class="header">{{ 'MAP.LEGENDS.HEADER.LEVELS' | translate }}</div>
        <div class="legend-container-level">
          <div class="gradient">
            <div 
              *ngFor="let level of levels" 
              class="color-segment" 
              [ngStyle]="{'background-color': level.color, 'border-left': '3px solid ' + level.color}">
            </div>
          </div>
          <div class="level-field" >
              <span *ngFor="let level of levels">{{ level.label | translate }}</span>
          </div>
        </div>
      </div>
</div>